export default {"src":"/_next/static/media/phone-icon.9b30d86f.svg","height":512,"width":512};